export enum TagEvent {
  Page = 'page',
  Login = 'login',
}
